// Single source of truth for the six use-case pages.
// Used by the homepage, footer, and any "explore by use case" block.
export interface UseCase {
  label: string;
  href: string;
  blurb: string;
}

export const USE_CASES: UseCase[] = [
  {
    label: "AI Competitor Monitoring",
    href: "/ai-competitor-monitoring/",
    blurb: "Track rival launches, funding, pricing, and hiring — automatically.",
  },
  {
    label: "AI Market Intelligence",
    href: "/ai-market-intelligence/",
    blurb: "Synthesized briefings on the sectors and themes that move your work.",
  },
  {
    label: "Personalized News Tracker",
    href: "/personalized-news-tracker/",
    blurb: "Your topics. Your schedule. No algorithm, no noise.",
  },
  {
    label: "Company Monitoring Tool",
    href: "/company-monitoring-tool/",
    blurb: "A running file on every account, portfolio company, or target.",
  },
  {
    label: "AI Research Assistant",
    href: "/ai-research-assistant/",
    blurb: "A 24/7 analyst that reads, synthesizes, cites, and remembers.",
  },
  {
    label: "Track Industry Trends",
    href: "/track-industry-trends/",
    blurb: "Spot shifts in your field before they become headlines.",
  },
];
